import { PetSimulation } from '../../../../@types/ResumePetisSimulationProposal'
import { AnimalsSecured } from '../../../../Types/AnimalStore'

export const mountedAnimalSimulation = (
  animal: PetSimulation,
): AnimalsSecured => {
  const { pack } = animal

  const newSafeAnimal: AnimalsSecured = {
    id: animal.id || '',
    sequence: animal.sequence || 0,
    OwnerId: 1, // TODO: ADD OWNER ID
    name: animal?.name || '',
    birthDate: animal?.birthDate || '',
    species: animal?.species || '',
    speciesCode: animal?.speciesCode || '',
    breed: animal?.breed || '',
    breedCode: animal?.breedCode || '',
    questionary: animal.questionnaire?.sections?.map((section) => ({
      id: section.code || '',
      title: section.name || '',
      questions: (section.questions || [])?.map((question) => ({
        id: question.code || '',
        question: question.description || '',
        responseTypeCode: question.responseTypeCode || '',
        order: question.order || 0,
        answer: question?.answer?.description?.toLowerCase() || '',
        conditions: question.conditions?.map((condition) => ({
          questionnaireConditionCode:
            condition?.questionnaireConditionCode || '',
          answerCode: condition?.answerCode || '',
          answerName: condition?.answerName || '',
          affectedQuestionCode: condition?.affectedQuestionCode || '',
          consequenceCode: condition?.consequenceCode || '',
        })),
      })),
    })),
    pack: {
      name: pack?.packId || '',
      price:
        pack?.premiums?.[0].premiumsValues?.invoiceRefPremium?.toString() || '',
      installment: pack?.installment || '',
      packId: pack?.packId || '',
      packDescription: pack?.packDescription || '',
      packName: pack?.name || '',
      recommended: pack?.recommended || false,
      packOrder: pack?.order || 0,
      premiums: pack?.premiums?.map((premium) => ({
        issueCost: premium?.premiumsValues?.issueCost,
        installment: pack?.installment || '',
        // premiumToDisplayed: 0,
        // subsequentsInstallmentValue: 0,
        premiumsValues: {
          insuredObjectTotalPremiumValue:
            premium.premiumsValues?.insuredObjectTotalPremiumValue?.toString() ||
            '',
          insuredObjectCommercialPremiumValue:
            premium.premiumsValues?.insuredObjectCommercialPremiumValue?.toString() ||
            '',
        },
        // installmentValuesList: [],
      })),
      coverages: pack?.coverages?.map((coverage) => ({
        // asfBranchCode: '084',
        coverageId: coverage?.coverageId || '',
        description: coverage?.coverageDescription || '',
        coverageName: coverage?.coverageName || '',
        accountingVariableCode: coverage?.accountingVariableCode || '',
        accountingValue: coverage?.accountingValue || 0,
        referencePeriodVariableCode:
          coverage?.referencePeriodVariableCode || '',
        referencePeriodValue: coverage?.referencePeriodValue || 0,
        accountingVariableDescription:
          coverage?.accountingVariableDescription || '',
        referencePeriodVariableDescription:
          coverage?.referencePeriodVariableDescription || '',
        isPreSelected: coverage?.isPreSelected || false,
        mandatory: coverage?.mandatory,
        order: coverage?.order,
        // minDiscount: null,
        // maxDiscount: null,
        // discountType: null,
        // accountingId: '850001',
        excessDeductible: {
          excessTypeCode: coverage?.excessDeductible?.excessTypeCode || '',
          excessMinValue: coverage?.excessDeductible?.excessMinValue || 0,
          excessMaxValue: coverage?.excessDeductible?.excessMaxValue || 0,
          excessMinPercent: coverage?.excessDeductible?.excessMinPercent || 0,
          excessMaxPercent: coverage?.excessDeductible?.excessMaxPercent || 0,
          excessValue: coverage?.excessDeductible?.excessValue || '',
          excessPercent: coverage?.excessDeductible?.excessPercent || 0,
          // selectedValue: '150',
          // textToDisplay: 'Tem o valor 10% (150€)',
          // excessTemporaryValues: [
          //   {
          //     valueCode: null,
          //     valueDescription: null,
          //     isDefault: false,
          //   },
          // ],
        },
        sumInsured: {
          sumInsuredTypeCode: coverage?.sumInsured?.sumInsuredTypeCode || '',
          sumInsuredValue: coverage?.sumInsured?.sumInsuredValue || 0,
          minValue: coverage?.sumInsured?.sumInsuredValue || 0, //TODO: Review if this value will be added
          maxValue: coverage?.sumInsured?.sumInsuredValue || 0, //TODO: Review if this value will be added
          // sumInsuredFixedValue: 0,
          relatedMinPercent: coverage?.sumInsured?.relatedMinPercent || 0,
          relatedMaxPercent: coverage?.sumInsured?.relatedMaxPercent || 0,
          // selectedValue: '',
          // textToDisplay: '',
          // capitalTiers: [],
        },
        // gracePeriod: {
        //   typeId: 'DA',
        //   days: 0,
        //   order: null,
        //   active: false,
        // },
        // riskFactors: [],
        coveragesValues: {
          coverageTotalPremiumValue:
            coverage?.coverageValues?.coverageTotalPremiumValue || 0,
          coverageCommercialPremiumValue:
            coverage?.coverageValues?.coverageCommercialPremiumValue || 0,
          // coverageTaxValues: [
          //   {
          //     taxId: '24',
          //     taxValue: 3.303,
          //     isClientTaxExempt: false,
          //     taxCurrency: 'EUR',
          //   },
          // ],
          // coverageChargeValues: null,
          // installments: null,
        },
        // commissions: [
        //   {
        //     coverageId: null,
        //     id: null,
        //     type: null,
        //     value: null,
        //     typeId: 'Angariacao',
        //     hasEvent: false,
        //     typeValue: 0,
        //     agentExternalId: null,
        //     agentId: null,
        //     negotiationPercentage: 0,
        //     annuities: null,
        //     installments: [
        //       {
        //         installmentNumber: '1',
        //         installmentValue: null,
        //       },
        //     ],
        //   },
        // ],
      })) as never, // TODO: Change this after adding all values
    },
  }

  return newSafeAnimal
}
